// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHealthPlanBaseDto } from './IHealthPlanBaseDto';
import {
    IHealthPlanBaseDtoFromJSON,
    IHealthPlanBaseDtoFromJSONTyped,
    IHealthPlanBaseDtoToJSON,
    IHealthPlanBaseDtoToJSONTyped,
} from './IHealthPlanBaseDto';
import type { IPlanYearDto } from './IPlanYearDto';
import {
    IPlanYearDtoFromJSON,
    IPlanYearDtoFromJSONTyped,
    IPlanYearDtoToJSON,
    IPlanYearDtoToJSONTyped,
} from './IPlanYearDto';
import type { IProcessingRuleDto } from './IProcessingRuleDto';
import {
    IProcessingRuleDtoFromJSON,
    IProcessingRuleDtoFromJSONTyped,
    IProcessingRuleDtoToJSON,
    IProcessingRuleDtoToJSONTyped,
} from './IProcessingRuleDto';
import type { IPlanLiteDto } from './IPlanLiteDto';
import {
    IPlanLiteDtoFromJSON,
    IPlanLiteDtoFromJSONTyped,
    IPlanLiteDtoToJSON,
    IPlanLiteDtoToJSONTyped,
} from './IPlanLiteDto';

/**
 * 
 * @export
 * @interface IEnrollmentMatrixDto
 */
export interface IEnrollmentMatrixDto {
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentMatrixDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentMatrixDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentMatrixDto
     */
    organization_type?: IEnrollmentMatrixDtoOrganizationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentMatrixDto
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentMatrixDto
     */
    valid_from?: string;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentMatrixDto
     */
    valid_to?: string;
    /**
     * 
     * @type {IPlanLiteDto}
     * @memberof IEnrollmentMatrixDto
     */
    plan_template?: IPlanLiteDto;
    /**
     * 
     * @type {IPlanYearDto}
     * @memberof IEnrollmentMatrixDto
     */
    plan_year?: IPlanYearDto;
    /**
     * 
     * @type {IProcessingRuleDto}
     * @memberof IEnrollmentMatrixDto
     */
    processing_rule?: IProcessingRuleDto;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentMatrixDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentMatrixDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentMatrixDto
     */
    processing_rule_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentMatrixDto
     */
    plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentMatrixDto
     */
    plan_year_id?: number;
    /**
     * 
     * @type {IHealthPlanBaseDto}
     * @memberof IEnrollmentMatrixDto
     */
    health_plan_template?: IHealthPlanBaseDto;
}

/**
* @export
* @enum {string}
*/
export enum IEnrollmentMatrixDtoOrganizationTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}


/**
 * Check if a given object implements the IEnrollmentMatrixDto interface.
 */
export function instanceOfIEnrollmentMatrixDto(value: object): value is IEnrollmentMatrixDto {
    return true;
}

export function IEnrollmentMatrixDtoFromJSON(json: any): IEnrollmentMatrixDto {
    return IEnrollmentMatrixDtoFromJSONTyped(json, false);
}

export function IEnrollmentMatrixDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEnrollmentMatrixDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'organization_type': json['organization_type'] == null ? undefined : json['organization_type'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'valid_from': json['valid_from'] == null ? undefined : json['valid_from'],
        'valid_to': json['valid_to'] == null ? undefined : json['valid_to'],
        'plan_template': json['plan_template'] == null ? undefined : IPlanLiteDtoFromJSON(json['plan_template']),
        'plan_year': json['plan_year'] == null ? undefined : IPlanYearDtoFromJSON(json['plan_year']),
        'processing_rule': json['processing_rule'] == null ? undefined : IProcessingRuleDtoFromJSON(json['processing_rule']),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'processing_rule_id': json['processing_rule_id'] == null ? undefined : json['processing_rule_id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_year_id': json['plan_year_id'] == null ? undefined : json['plan_year_id'],
        'health_plan_template': json['health_plan_template'] == null ? undefined : IHealthPlanBaseDtoFromJSON(json['health_plan_template']),
    };
}

export function IEnrollmentMatrixDtoToJSON(json: any): IEnrollmentMatrixDto {
    return IEnrollmentMatrixDtoToJSONTyped(json, false);
}

export function IEnrollmentMatrixDtoToJSONTyped(value?: IEnrollmentMatrixDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'organization_type': value['organization_type'],
        'priority': value['priority'],
        'valid_from': value['valid_from'],
        'valid_to': value['valid_to'],
        'plan_template': IPlanLiteDtoToJSON(value['plan_template']),
        'plan_year': IPlanYearDtoToJSON(value['plan_year']),
        'processing_rule': IProcessingRuleDtoToJSON(value['processing_rule']),
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'processing_rule_id': value['processing_rule_id'],
        'plan_id': value['plan_id'],
        'plan_year_id': value['plan_year_id'],
        'health_plan_template': IHealthPlanBaseDtoToJSON(value['health_plan_template']),
    };
}

